export default __webpack_public_path__ + "static/media/rolling.ecb4a58e.gif";